import React, { useContext } from 'react';
import { Button } from 'antd';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { TaskCreateExtras } from '@totem/components/ticketing/types';

type Props = {
  extras?: TaskCreateExtras;
};

const ButtonCreateTask = ({ extras }: Props) => {
  const { onAction } = useContext(TicketContext);
  return (
    <Button
      type="primary"
      onClick={() =>
        onAction(
          'show-task-create',
          extras !== null ? JSON.stringify(extras) : '',
        )
      }
    >
      Add Task
    </Button>
  );
};

export default ButtonCreateTask;
